/**
 * Flagsmith flag gating the experimental "Pagination style" setting.
 *
 * eag-grid cannot import the `@dms/feature-flags` enum (module boundaries:
 * `scope:features` may only depend on `shared/*` / `type:ui` / `type:repository`),
 * so the flag name lives here and is consumed via `<Show whenFeatureEnabled>`
 * from platform/foundation.
 *
 * Scope — DELIBERATELY gates only the SettingsPanel entry point, not the footer
 * rendering. With the flag off, no user can newly select 'INPUT', and since no
 * preset predates this feature with 'INPUT' persisted, the default state is
 * byte-identical to pre-feature behavior. A user who selected 'INPUT' while the
 * flag was on keeps their input footer after a rollback (harmless, purely
 * visual) but loses the UI to change it — if a rollback must also revert those
 * users, gate the variant mapping in components/Pagination/GridPagination.tsx too.
 */
export const PAGINATION_DISPLAY_MODE_FEATURE_FLAG = 'eag_grid_experimental_pagination_display_mode';
